import React from 'react';
import { Card, Button, Steps, Divider, Space, Row, Col } from 'antd';
import { MailOutlined, LockOutlined } from '@ant-design/icons';
import SetupSteps from './SetupSteps';
import { useTranslation } from 'react-i18next';

const { Step } = Steps;

export default function SetupCard({
  step,
  pending,
  children,
  onDone,
  onCancel,
}) {
  const { t } = useTranslation();

  return (
    <Card className="setup-card">
      <Steps className="setup-card__steps" current={step}>
        <Step title={t('setup-steps-company')} />
        <Step title={t('setup-steps-server')} />
        <Step title={t('setup-steps-smtp')} />
      </Steps>
      {children}
      <Divider />
      <Space className="setup-card__controls">
        {step > 0 ? (
          <Button type="default" onClick={onCancel}>
            {t('setup-steps-previous')}
          </Button>
        ) : null}
        <Button type="primary" loading={pending} onClick={onDone}>
          {t('setup-steps-next')}
        </Button>
      </Space>
    </Card>
  );
}
